<template>
  <vue-apex-charts
    class="inslnchart"
    ref="refInsightChartLine"
    type="line"
    height="550"
    :options="chartOptionsLine"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { debounce, __ } from 'lodash'

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
const shapeMap = ['circle', 'triangle', 'square', 'sparkle', 'diamond'];

const localeFloatOpt = { minimumFractionDigits: 1, maximumFractionDigits: 1 };

var seriesFreq = [];
var seriesRate = [];  

export default {
  name: "InsightChartLine",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartDisplayType: "",

      chartOptionsLine: {
        chart: {
          height: 500,
          type: "line",
          stacked: false,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          line: {
                dataLabels: {
                  position: 'top'
                },
              }
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'middle',
          formatter: function (val, opt) {
            if (opt.w.globals.dom.baseEl.__vue__.chartDisplayType === "비율(%)")
              return (Math.round(val * 100) / 100).toLocaleString(undefined, localeFloatOpt) + "%"
            else
              return (Math.round(val * 100) / 100).toLocaleString()
          },
          offsetY: -5,
          background: {
            enabled: false
          },
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1.5,
          curve: 'smooth',
        },
        markers: {
          size: 4,
          hover: {
            size: 5
          }
        },
        xaxis: {
          categories: [],
          tooltip: {
            enabled: false,
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
              color: "#008FFB",
            },
            labels: {
              style: {
                colors: "#008FFB",
              },
              formatter(value) {
                let val = Math.round(value * 10) / 10;

                if (val >= 10 ** 3 && val < 10 ** 6)
                  return (val / 1000).toLocaleString(undefined, localeFloatOpt) + 'K';
                else if (val >= 10 ** 6)
                  return (val / 1000000).toLocaleString(undefined, localeFloatOpt) + 'M';
                else
                  return (val).toLocaleString(undefined, localeFloatOpt);
              },
            },
            title: {
              text: 'Search Volumn',
              style: {
                color: "#008FFB",
              },
            },
            tooltip: {
              enabled: false,
            },
          },
        ],
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "center",
          itemMargin: {
            horizontal: 5,
            vertical: 2,
          },
          onItemClick: {
            toggleDataSeries: true
          },
          onItemHover: {
            highlightDataSeries: true
          },
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
      },

      series: [],
    };
  },
  props: {
    insightChartLine: {
      type: Array,
      default: () => [],
    },
    lineChartCategories: {
      type: Array,
      default: () => [],
    },
    lineChartDesc: {
      type: Array,
      default: () => [],
    },
    isChartInit: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    check_displayType() {
      return this.$store.getters.getSelectedInsightDisplayType;
    }
  },
  watch: {
    check_displayType(val) {
      let insightChartLineOption = null;
      this.chartDisplayType = val;

      if (this.chartDisplayType === "비율(%)") {
        this.series = seriesRate != null ? _.cloneDeep(seriesRate) : [];

        insightChartLineOption = {
          yaxis: {
            min: 0,
            max: 100,
            labels: {
              formatter(value) {
                return (Math.round(value * 10) / 10).toLocaleString(undefined, localeFloatOpt);
              },
            },
          },
        };
      }
      else {
        insightChartLineOption = {
          yaxis: {
            min: 0,
            max: undefined,
            labels: {
              formatter(value) {
                let val = Math.round(value * 10) / 10;

                if (val >= 10 ** 3 && val < 10 ** 6)
                  return (val / 1000).toLocaleString(undefined, localeFloatOpt) + 'K';
                else if (val >= 10 ** 6)
                  return (val / 1000000).toLocaleString(undefined, localeFloatOpt) + 'M';
                else
                  return (val).toLocaleString(undefined, localeFloatOpt);
              },
            },
          },
        };

        this.series = seriesFreq != null ? _.cloneDeep(seriesFreq) : [];
      }

      this.$refs.refInsightChartLine.updateOptions(insightChartLineOption, true);  
    },

    insightChartLine(newVal) {
      if (!this.isChartInit) {
        const insightChartLineOption = {
          noData: {
            text: '분석중...',
            style: {
              color: '#1817E7',
            }
          },
        };
        this.series = [];
        this.$refs.refInsightChartLine.updateOptions(insightChartLineOption, true);
        return;
      }

      if(this.lineChartDesc.length > 0){
        this.setValues(newVal, this.lineChartCategories, this.lineChartDesc)
      }
    },
  },
  methods: {
    setValues(newVal, newCategories, newDesc){
      seriesRate = _.cloneDeep(newVal);
      seriesFreq = _.cloneDeep(newVal);

      for (let i = 0; i < seriesFreq.length; i++) {
        for (const j in newDesc[i]) 
            seriesFreq[i].data[j] = newDesc[i][j];
      }  

      if (this.chartDisplayType === "비율(%)")
        this.series = _.cloneDeep(seriesRate);
      else
        this.series = _.cloneDeep(seriesFreq);

      var colors = [];
      var shapes = [];
      
      for (let i = 0; i < newVal.length; i++) {
        shapes.push(shapeMap[Math.floor(i / colorMap.length) % shapeMap.length]);
        colors.push(colorMap[i % colorMap.length]);
      }

      const insightChartLineOption = {
        xaxis: {
          categories: newCategories,
        },
        tooltip: {
          followCursor: true,
          shared: false,
          intersect: true,
          enabled: true,
          fixed: {
            enabled: false,
          },
          custom: function({series, seriesIndex, dataPointIndex, w}, description=newDesc) {    
            var val;

            if (w.globals.dom.baseEl.__vue__.chartDisplayType === "비율(%)")
              val = parseFloat(seriesRate[seriesIndex].data[dataPointIndex]).toLocaleString(undefined, localeFloatOpt) + "%"   
            else
              val = parseFloat(seriesFreq[seriesIndex].data[dataPointIndex]).toLocaleString()   

            var hexColor = w.globals.colors[seriesIndex].replace('#', '')
            const r = parseInt(hexColor.substring(0, 2), 16)
            const g = parseInt(hexColor.substring(2, 4), 16)
            const b = parseInt(hexColor.substring(4, 6), 16)
            hexColor = `rgb(${r}, ${g}, ${b})`

            return '<div>' +
              '<div class="apexcharts-tooltip-title" style="font-family: NanumBarunGothic; font-size: 12px;">' + w.globals.categoryLabels[dataPointIndex] + '</div>' +
              '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;">' +
              '<span class="apexcharts-tooltip-marker" style="background-color: ' +  hexColor + ';"></span>' + 
              '<div class="apexcharts-tooltip-text" style="font-family: NanumBarunGothic; font-size: 12px;">' +
              '<div class="apexcharts-tooltip-y-group">' +
              '<span class="apexcharts-tooltip-text-label">' + w.globals.seriesNames[seriesIndex] + ' : ' + '</span>' +
              '<span class="apexcharts-tooltip-text-value">' + val + '</span>' +
              '</div>' +
              '<div class="apexcharts-tooltip-z-group">' +
              '<span class="apexcharts-tooltip-text-z-label"></span>' +
              '<span class="apexcharts-tooltip-text-z-value"></span>' +
              '</div></div></div></div>';
          }
      },
        colors: colors,
        markers: {
          shape: shapes,
        },
        legend: {
          markers: {
            shape: shapes,
          }
        },
      };

      this.$refs.refInsightChartLine.updateOptions(insightChartLineOption, true);
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.inslnchart .apexcharts-canvas .apexcharts-legend-series .apexcharts-legend-text {
  color: #6e6b7b !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  padding-left: 0px;
}

.inslnchart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.inslnchart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

.inslnchart .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  position: relative;
  top: 0px;
  margin-right: 5px;
  border-radius: 50%;
}

.inslnchart .apexcharts-canvas .apexcharts-text {
  font-family: NanumBarunGothicB !important;
}

</style>
  